import { Provider } from './providers';
import { Html } from './components';

const MathJax = {
  Provider,
  Html,
};

export default MathJax;
